/**
 * What the "nächstgelegene Termine" search should orbit for a shelf card, and
 * which plane it should search.
 *
 * Its own module rather than an inline helper because three things vary and none
 * of them are guessable from the card alone:
 *  - In Dauertermin view the card's id belongs to the ContinuousAppointment
 *    table, which the dated lookup would never find.
 *  - A slot pin ("Umziehen → Nur diese") is keyed by its TIMESLOT id and keeps
 *    the host appointment under `pinnedAppointmentId` — sending the slot id
 *    resolves to nothing.
 *  - The address id rides along as a fallback for cards whose id resolves to no
 *    geocoded address server-side.
 */

import { AppointmentDto } from "../../../api-client";

export interface ClosestSearchTarget {
  appointmentId?: string;
  continuousAppointmentId?: string;
  addressId?: string;
  scope: "appointments" | "continuous";
}

export const closestTargetForCard = (
  appointment: AppointmentDto,
  isContinuous: boolean
): ClosestSearchTarget => {
  const addressId = appointment.address?.id;
  if (isContinuous) {
    return {
      continuousAppointmentId: appointment.id,
      addressId,
      scope: "continuous",
    };
  }
  const hostId = (appointment as any).isSlotPin
    ? (appointment as any).pinnedAppointmentId
    : appointment.id;
  return { appointmentId: hostId, addressId, scope: "appointments" };
};
